export enum AttesteringsStatus {
    NivåEjRedo = 120,
    NivåRedo = 114,
    Godkänt = 106,
    Nekat = 110,
    Bevakar = 98
}
export enum Atteststatus {
    Nej = 120,
    Aktiv = 97,
    Ja = 106,
    Nekad = 110,
    Bevakad = 98
}
export enum Exportstatus {
    Ja = 106,
    Nej = 110,
    Inaktuell = 105,
    Ankomst = 97
}
export enum Fakturastatus {
    Ja = 106,
    Nej = 110
}
export enum Händelsetyp {
    Skapad = 0,
    Faktinfo_godkänd = 1,
    Kontering_godkänd = 2,
    Attesterad = 3,
    Exporterad = 4,
    Arkiverad = 5,
    Fritext = 6,
    Nekad = 7,
    Bevakning = 8,
    Attestkedja_godkänd = 9,
    Faktinfo_ändrad = 10,
    Kontering_ändrad = 11,
    Attestkedja_ändrad = 12,
    Anteckning_ändrad = 13,
    Avarkiverad = 14,
    Tillbaka_Förra_Nivån = 15,
    Attestkedja_person_ersatt = 16
}

export interface BasePaginatedQuery {
    page?: number | null;
    pageSize?: number | null;
    sortColumn?: string;
    sortAsc?: boolean | null;
}

export interface InvoiceSearchRequest extends BasePaginatedQuery {
    leverantorSokId?: string[];
    supplierIds?: number[];
    fakturaText?: string[];
    fakturaNr?: string;
    kontoNr?: string[];
    kontoNrAvancerat?: string;
    kostnadsstalle?: string[];
    projekt?: string[];
    objekt3?: string[];
    exportId?: number[];
    exportIdAvancerat?: string;
    interntIdAvancerat?: string;
    attestantId?: number[];
    attesteringStatus?: AttesteringsStatus[];
    loggHandelseTyper?: Händelsetyp[];
    faktDatumStart?: string | null;
    faktDatumSlut?: string | null;
    forfDatumStart?: string | null;
    forfDatumSlut?: string | null;
    summaMin?: number | null;
    summaMax?: number | null;
    momsMin?: number | null;
    momsMax?: number | null;
    arkiverad?: boolean | null;
    konterad?: boolean | null;
    loggText?: string[];
    invoiceLabelList?: number[];
    komplettaFakturor?: boolean;
    fakturaIdSkip?: number[];
    attestStatusList?: Atteststatus[];
}


export interface SupplierInvoice {
    id: number;
    lopNr: number;
    exportId: number;
    supplierId: number | null;
    supplier: SupplierSubset;
    invoiceNr: string;
    ocrNr: string;
    invoiceDate: Date | null;
    dueDate: Date | null;
    bookDate: Date | null;
    attesterad: Atteststatus;
    godkand: Fakturastatus;
    konterad: Fakturastatus;
    exporterad: Exportstatus;
    kapital: SupplierInvoiceAmounts;
    konteringsRader: SupplierInvoiceRow[];
    ejBetalFil: boolean | null;
}

export interface SupplierSubset {
    id: number;
    levId: string;
    name: string;
}

export interface SupplierInvoiceAmounts {
    kapitalInkl: number;
    moms: number;
    valutaKod: string;
    kurs: number;
}

export interface SupplierInvoiceRow {
    radNr: number;
    kontoNr: number;
    value: number;
    kst: string;
    proj: string;
    objekt3: string;
    objekt4: string;
    kvantitet: number | null;
    perStartDatum: Date | null;
    perAntalManader: number | null;
    periodisering: SupplierInvoiceRow;
}

export interface ResponseStatus {
    errorCode: string;
    message: string;
    stackTrace: string;
}

export interface BaseResponseDto {
    responseStatus: ResponseStatus;
}
export interface SupplierInvoiceImageResponse extends BaseResponseDto {
    nrOfPages: number;
}

import { GenericSearchWrapper } from '../index';
export { GenericSearchWrapper };